import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

export const refreshPageIfAuthFails = store.effects.create((feature: Feature) =>
  feature.actions.authenticate.error.observe().pipe(
    rxjs.tap(() => {
      window.location.reload()
    }),
    rxjs.ignoreElements(),
  ),
)
